import React from 'react'
import axios from 'axios'
import { useNavigate, Link } from 'react-router-dom'

const NextComparisonLink = ({listId, setError}) => {
  const navigate = useNavigate()

  const createComparisonAndNavigate = () => {
    axios.post(`/api/lists/${listId}/next_comparison`)
      .then(response => {
        const comparison = response.data
        const nextUrl = `/lists/${listId}/comparisons/${comparison.id}`
        navigate(nextUrl)
      })
      .catch(err => {
        setError(JSON.stringify(err))
      })
  }

  return (
    <Link onClick={() => createComparisonAndNavigate()}>
      Next Random Comparison
    </Link>
  )
}

export default NextComparisonLink

